import { HttpHeaders } from '@angular/common/http';

export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

export const httpOptionsPdf = {
    headers: new HttpHeaders({ 'Accept': 'application/pdf', 'responseType':'arraybuffer' })
};

export const header = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'POST',
    })
};

export const httpOptionsOauth = {
    headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
    })
};
